import { useState, useEffect } from 'react';

/**
 * Hook that returns true when viewport is below the given breakpoint.
 * Default 1024px matches Tailwind's `lg` breakpoint (where sidebar switches to mobile drawer).
 * Uses matchMedia for efficiency — only fires when the breakpoint boundary is crossed.
 */
export function useIsMobile(breakpoint = 1024): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    // Sync on mount in case SSR hydration mismatched
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, [breakpoint]);

  return isMobile;
}
